<script>
  export default {
    name: 'CardDiscountTicket',
    props: {
      isPass: {
        type: Boolean,
        default: () => false
      },
      ticket: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <v-sheet max-width="850" width="100%" class="d-flex flex-column flex-sm-row align-stretch justify-center justify-sm-start rounded-lg mt-4 pa-4">
    <v-sheet height="100%" max-width="33%" min-width="33%" width="33%" class="d-flex align-start justify-center mx-auto mx-sm-0 mb-2 mb-sm-0">
      <img :src="ticket.logo" :alt="`logo for ${ticket.title}`" class="ticket-logo rounded-lg" />
    </v-sheet>
    <v-card flat title class="d-flex flex-column ml-0 ml-sm-4">
      <v-card-title v-html="ticket.title" class="text-h5 primary--text font-weight-bold break-word pa-0"></v-card-title>
      <v-card-text class="d-flex flex-column align-start justify-start pa-0">
        <p v-if="ticket.price" class="text-body-1 font-weight-bold success--text">
          {{ ticket.price }}
          <span class="black--text text-caption font-weight-light">({{ ticket.expiration ? `expires ${ticket.expiration}` : 'no expiration' }})</span>
        </p>
        <p v-if="ticket.discount" class="text-body-1 font-weight-bold success--text">
          {{ ticket.discount }} discount<span v-if="ticket.expiration" class="black--text text-caption font-weight-light">({{ ticket.expiration }})</span>
        </p>
        <template v-if="ticket?.details?.length">
          <ul v-if="ticket?.details?.length > 1" class="py-4 py-sm-8" style="max-width: 150ch">
            <li v-for="(detail, k) in ticket.details" :key="k">{{ detail }}</li>
          </ul>
          <p v-else class="py-8">{{ ticket.details[0] }}</p>
        </template>
      </v-card-text>
      <v-card-actions class="pt-4 pa-sm-0 mt-auto d-flex flex-row justify-space-start">
        <v-btn v-if="ticket.homepage" color="primary" :href="ticket.homepage" outlined target="_blank" class="font-weight-bold"
          ><v-icon left color="primary">mdi-home</v-icon>HOME</v-btn
        >
        <template v-if="ticket.ticket_url">
          <v-btn v-if="ticket.ticket_url === 'eipl'" color="primary"><v-icon left color="secondary">mdi-library-outline</v-icon>LIBRARY PICKUP</v-btn>
          <v-btn v-else color="primary" :href="ticket.ticket_url" target="_blank" class="font-weight-bold"
            ><v-icon left color="secondary">{{ `mdi-${isPass ? 'bank' : 'ticket-outline'}` }}</v-icon
            >{{ isPass ? 'RESERVE' : 'TICKETS' }}</v-btn
          >
        </template>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<style scoped>
  p {
    margin: 0;
  }

  .ticket-logo {
    object-fit: contain;
    /* border-radius: 50%; */
    height: 200px;
    width: 200px;
  }
</style>
